import { Accordion, AccordionTypes, HStack, Icon, Stack, Text, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { ReportingEnumsTermsLegalEntityScenarioEnum } from '@genial/services/dist/models';
import { Button } from 'native-base';
import React, { useEffect, useState } from 'react';

import { multipleTermsDescription } from '../../constants';

import { AccordionItem } from './components/AccordionItem';

export namespace DocumentsCenterAccordionTypes {
  export interface Props {
    title: string;
    children?: multipleTermsDescription;
    isMobile: boolean;
    fileName?: string;
    isLoading: boolean;
    accordionState: AccordionTypes.Status;
    onExpand: () => void;
    onDownload: (fileName: ReportingEnumsTermsLegalEntityScenarioEnum) => void;
  }
}

export const DocumentsCenterAccordion: React.FC<DocumentsCenterAccordionTypes.Props> = ({
  title,
  children,
  fileName,
  isMobile,
  isLoading,
  accordionState,
  onExpand,
  onDownload,
}) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  useEffect(() => {
    setOpenIndex(null);
  }, [accordionState]);

  return (
    <Stack
      space={{ base: 'stack.nano', sm: 'stack.quarck' }}
      justifyContent="space-between"
      borderRadius="sm"
      padding="inset.nano"
      borderWidth={1}
      borderColor="neutral.lightest">
      <Accordion
        testId="alerts-info"
        status={accordionState}
        onPress={onExpand}
        hasShadow={false}
        containerProps={{
          flex: 1,
          w: 'full',
        }}>
        <Accordion.Visible w="full" flex={1}>
          <HStack justifyContent="space-between" space={Spacing['inline.nano']}>
            <HStack flex={1} alignItems="center" space={Spacing['inline.nano']}>
              <Icon name="PageContent" size="xxxs" />
              <Text variant="semibold" fontSize="md">
                {title}
              </Text>
            </HStack>
            {!isMobile && (
              <Button
                variant="textLink"
                isDisabled={isLoading}
                isLoading={isLoading}
                isLoadingText="Baixar"
                spinnerPlacement="start"
                onPress={() =>
                  onDownload((fileName as ReportingEnumsTermsLegalEntityScenarioEnum) || '')
                }
                leftIcon={
                  <Icon name="ArrowDownload" size="xxxs" color="brand.tertiary.principal" />
                }>
                Baixar
              </Button>
            )}
          </HStack>
        </Accordion.Visible>
        <Accordion.Expanded>
          <VStack px={Spacing['stack.xxxs']}>
            {children?.map((item, index) => (
              <AccordionItem
                key={item.title}
                showContent={openIndex === index}
                isLast={index === children.length - 1}
                onPress={() => setOpenIndex((prev) => (prev === index ? null : index))}
                {...item}
              />
            ))}
            {isMobile && (
              <Button
                variant="primary"
                isDisabled={isLoading}
                onPress={() =>
                  onDownload((fileName as ReportingEnumsTermsLegalEntityScenarioEnum) || '')
                }>
                BAIXAR DOCUMENTOS
              </Button>
            )}
          </VStack>
        </Accordion.Expanded>
      </Accordion>
    </Stack>
  );
};
